// extracted by mini-css-extract-plugin
export default {"container":"region-select_container__Yn2C7","label":"region-select_label__V-Olt"};